<template>
  <v-dialog v-model="dialog" persistent max-width="100%">
    <v-card>
      <v-card-title class="pt-2 pb-0">{{ tituloModal }}</v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pb-0" v-if="!verificar">
        <v-form>
          <v-row dense>
            <v-col cols="12" md="6" lg="3">
              <v-text-field
                :value="$store.state.CARGO.sede.nombre"
                disabled
                label="Sede Origen"
                outlined
                dense
                hide-details></v-text-field>
            </v-col>

            <v-col cols="12" md="6" lg="3">
              <vue-select
                v-model="agregarDetalle.cuenta_origen"
                class="style-chooser"
                placeholder="Seleccione Cuenta Origen"
                label="nro"
                :options="cuentaOrigenItems">
                <div slot="no-options">Lo sentimos, no hay opciones de coincidencia.</div>

                <template #option="{ cuenta, nro }">
                  {{ nro }}
                  <br />
                  {{ cuenta }}
                </template>
              </vue-select>
            </v-col>

            <v-col cols="12" md="6" lg="3">
              <vue-select
                v-model="agregarDetalle.sede_destino"
                class="style-chooser"
                placeholder="Seleccione Sede Destino"
                label="nombre"
                :clearable="false"
                @input="obtenerCuentasDestino()"
                :options="sedeItems">
                <template #option="{ nombre, origen }">
                  <span style="display: block; font-size: 0.925rem">{{ nombre }}</span>
                  <small>{{ origen.toUpperCase() }}</small>
                </template>
              </vue-select>
            </v-col>

            <v-col cols="12" md="6" lg="3">
              <vue-select
                :disabled="!agregarDetalle.sede_destino"
                v-model="agregarDetalle.cuenta_destino"
                class="style-chooser"
                placeholder="Seleccione Cuenta Destino"
                label="nro"
                :options="cuentaDestinoItems">
                <div slot="no-options">Lo sentimos, no hay opciones de coincidencia.</div>

                <template #option="{ cuenta, nro, tipo }">
                  <span style="display: block; font-size: 1rem">
                    {{ nro }} <small style="font-size: 0.725rem">({{ tipo.toUpperCase() }})</small>
                  </span>
                  {{ cuenta }}
                </template>
              </vue-select>
            </v-col>

            <v-col cols="12" md="12" lg="4">
              <vue-select
                v-model="agregarDetalle.clasificador"
                class="style-chooser"
                placeholder="Seleccione una Cuenta"
                label="nombre"
                :selectable="(option) => !option.esta_obsoleto"
                @input="obtenerPartida()"
                :options="partidasItems">
                <template #option="{ nombre, saldo }">
                  <span style="display: block; font-size: 0.925rem">{{ nombre }}</span>
                  <small>Saldo: {{ formatearValorAMoneda(saldo) }}</small>
                </template>
              </vue-select>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <v-textarea
                v-model="agregarDetalle.detalle"
                label="Detalle"
                placeholder=" "
                rows="4"
                outlined
                dense
                hide-details></v-textarea>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <v-row>
                <v-col cols="12">
                  <div class="d-flex">
                    <v-file-input
                      v-model="archivo"
                      class="file-input"
                      label="Adjuntar Respaldo JPG, PNG, PDF (Opcional)"
                      accept="image/jpeg, image/png, image/jpg, application/pdf"
                      :prepend-icon="''"
                      prepend-inner-icon="mdi-paperclip"
                      outlined
                      dense
                      clearable
                      hide-details
                      @change="onFileChange"></v-file-input>

                    <v-btn
                      class="ml-2"
                      title="Previsualizar archivo"
                      color="primary"
                      icon
                      :disabled="!previsualizacion"
                      @click="verPrevisualizacion">
                      <v-icon>mdi-file-eye</v-icon>
                    </v-btn>
                  </div>
                </v-col>

                <v-col cols="12" md="8">
                  <v-text-field
                    class="mb-4"
                    v-model="agregarDetalle.importe"
                    label="Importe"
                    placeholder=" "
                    value=" "
                    outlined
                    dense
                    hide-details></v-text-field>

                  <v-text-field
                    class="mt-4"
                    disabled
                    :value="agregarDetalle.saldo"
                    label="Saldo presupuesto"
                    placeholder="Saldo presupuesto"
                    outlined
                    dense
                    hide-details></v-text-field>
                </v-col>

                <v-col cols="12" md="4" style="padding-bottom: 0px !important">
                  <v-btn color="primary" @click="agregar"> Agregar </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-text class="pt-2 pb-0">
        <ag-grid-vue
          :gridOptions="gridOptions"
          class="ag-theme-balham ag-grid-table-presupuesto-modal-solicitud"
          :columnDefs="definicionColumnas"
          :defaultColDef="defaultColDef"
          @grid-ready="onGridReady"
          :rowData="form.detalle_solicitud"
          :suppressRowClickSelection="true"
          colResizeDefault="shift"
          :animateRows="true"
          :floatingFilter="false"
          :rowClassRules="rowClassRules"
          :pinnedBottomRowData="pinnedBottomRowData"
          @rowClicked="onRowClicked($event)"
          :alwaysShowVerticalScroll="true"
          @first-data-rendered="onFirstDataRendered">
        </ag-grid-vue>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pt-0">
        <v-btn color="blue darken-1" text :disabled="cargando" @click.prevent="cerrarModal"> Cerrar </v-btn>
        <v-btn
          v-if="!verificar"
          color="blue darken-1"
          text
          :disabled="cargando"
          :loading="cargando"
          @click.prevent="validar">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>

    <ConfirmacionAccion
      ref="confirmacionAccion"
      :titulo="accion.titulo"
      :mensaje="accion.mensaje"
      :realizandoAccion="accion.realizandoAccion"
      @aceptar="aceptarAccion" />

    <ModalVerPdf ref="modalVerPdfRef" />

    <ModalPrevisualizacionAdjunto ref="modalPrevisualizacionAdjuntoRef" />
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import {
  ESTADOS_DETALLE_SOLICITUD,
  formatearValorAMoneda,
  obtenerColorEstadoDetalleSolicitud,
  OPERACIONES_DETALLE_SOLICITUD,
  TIPOS_SOLICITUD,
} from '../utils';
import modalSolicitudRecursosMixin from '../mixins/modal-solicitud-recursos-mixin';

export default {
  name: 'ModalFormSolicitudTransferenciaRecursos',
  mixins: [modalSolicitudRecursosMixin],
  data() {
    return {
      tipoSolicitud: TIPOS_SOLICITUD.RECURSOS,
      detalleSeleccionadoId: null,
      rowClassRules: {
        'nuevo-registro': (params) => !params.node.rowPinned && !params.data?.id,
      },
      columnDefs: [
        {
          headerName: '#',
          cellRenderer: function (param) {
            if (param.node.rowPinned) {
              return undefined;
            } else {
              return param.node.rowIndex + 1;
            }
          },
          filter: false,
          minWidth: 70,
          maxWidth: 70,
        },
        {
          headerName: 'BANCO ORIGEN',
          field: 'banco_origen',
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'CUENTA ORIGEN',
          field: 'cuenta_origen',
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'SEDE DESTINO',
          field: 'sede_destino',
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'BANCO DESTINO',
          field: 'banco_destino',
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'CUENTA DESTINO',
          field: 'cuenta_destino',
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'CUENTA',
          field: 'clasificador',
          filter: false,
          minWidth: 180,
          maxWidth: 180,
        },
        {
          headerName: 'ADJUNTO',
          cellRenderer: (params) => {
            const archivoId = params.data.archivo_id;
            const archivo = params.data.archivo;

            if (params.node.rowPinned) {
              return undefined;
            } else if (!archivoId) {
              if (archivo) {
                return /*html */ `
              <button type="button" style="margin-bottom: 8px;" class="v-btn v-btn--outlined theme--light v-size--x-small grey--text">
                  <span class="v-btn__content" data-action-type="${OPERACIONES_DETALLE_SOLICITUD.VER_ADJUNTO_NO_SUBIDO}">
                      ADJUNTO (*)
                      <i aria-hidden="true" class="v-icon notranslate mdi mdi-file-outline"></i>
                  </span>
              </button>`;
              } else {
                return /*html */ `<span>-</span>`;
              }
            } else if (this.detalleSeleccionadoId === params.data.id) {
              return /*html */ `
                <div role="progressbar" aria-valuemin="0" aria-valuemax="100" class="v-progress-linear v-progress-linear--visible theme--dark" style="margin-top: 8px; height: 8px;">
                  <div class="v-progress-linear__background primary" style="opacity: 0.3; left: 0%; width: 100%;"></div>
                  <div class="v-progress-linear__buffer"></div>
                  <div class="v-progress-linear__indeterminate v-progress-linear__indeterminate--active">
                    <div class="v-progress-linear__indeterminate long primary"></div>
                    <div class="v-progress-linear__indeterminate short primary"></div>
                  </div>
                </div>`;
            } else {
              return /*html */ `
              <button type="button" style="margin-bottom: 8px;" class="v-btn v-btn--outlined theme--light v-size--x-small blue--text">
                  <span class="v-btn__content" data-action-type="${OPERACIONES_DETALLE_SOLICITUD.VER_ADJUNTO}">
                      ADJUNTO
                      <i aria-hidden="true" class="v-icon notranslate mdi mdi-file-outline"></i>
                  </span>
              </button>`;
            }
          },
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'CONTABLE',
          field: 'cuenta_contable',
          filter: false,
          minWidth: 180,
          maxWidth: 180,
        },
        {
          headerName: 'DETALLE',
          field: 'detalle',
          editable: function (param) {
            return !param.node.rowPinned && param.data.estado == ESTADOS_DETALLE_SOLICITUD.PENDIENTE;
          },
          singleClickEdit: true,
          filter: false,
          minWidth: 200,
          // maxWidth: 200,
        },
        {
          headerName: 'IMPORTE',
          field: 'importe',
          editable: function (param) {
            return param.node.rowPinned
              ? false
              : param.data.estado != ESTADOS_DETALLE_SOLICITUD.APROBADO
              ? true
              : false;
          },
          singleClickEdit: true,
          valueFormatter: function (param) {
            return formatearValorAMoneda(param.value);
          },
          valueParser: numberParser,
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'SALDO',
          field: 'saldo',
          valueFormatter: function (param) {
            if (param.node.rowPinned) {
              return undefined;
            }
            return formatearValorAMoneda(param.value);
          },
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'ESTADO',
          cellRenderer: function (param) {
            if (param.node.rowPinned) {
              return undefined;
            } else {
              const color = obtenerColorEstadoDetalleSolicitud(param.data.estado);

              return /*html */ `<span style="color: ${color}">${param.data.estado}</span>`;
            }
          },
          filter: false,
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: '',
          filter: false,
          minWidth: 125,
          cellRenderer: function (param) {
            if (param.node.rowPinned) {
              return undefined;
            } else if (param.data.estado == ESTADOS_DETALLE_SOLICITUD.PENDIENTE) {
              const textoBoton = param.data?.id ? 'ELIMINAR' : 'QUITAR';
              const colorBoton = param.data?.id ? 'error--text' : 'orange--text';

              return /*html */ `
              <button type="button" style="margin-bottom: 8px;" class="v-btn v-btn--outlined theme--light v-size--x-small ${colorBoton}">
                  <span class="v-btn__content" data-action-type="${OPERACIONES_DETALLE_SOLICITUD.REMOVER}">
                      ${textoBoton}
                      <i aria-hidden="true" class="v-icon notranslate mdi mdi-close"></i>
                  </span>
              </button>`;
            } else {
              return undefined;
            }
          },
        },
      ],
      columnDefsVerificar: [
        {
          headerName: '#',
          cellRenderer: function (param) {
            if (param.node.rowPinned) {
              return undefined;
            } else {
              return param.node.rowIndex + 1;
            }
          },
          filter: false,
          minWidth: 70,
          maxWidth: 70,
        },
        {
          headerName: 'BANCO ORIGEN',
          field: 'banco_origen',
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'CUENTA ORIGEN',
          field: 'cuenta_origen',
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'SEDE DESTINO',
          field: 'sede_destino',
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'BANCO DESTINO',
          field: 'banco_destino',
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'CUENTA DESTINO',
          field: 'cuenta_destino',
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'CUENTA',
          field: 'clasificador',
          filter: false,
          minWidth: 180,
          maxWidth: 180,
        },
        {
          headerName: 'CONTABLE',
          field: 'cuenta_contable',
          filter: false,
          minWidth: 180,
          maxWidth: 180,
        },
        {
          headerName: 'DETALLE',
          field: 'detalle',
          filter: false,
          minWidth: 200,
          // maxWidth: 200,
        },
        {
          headerName: 'IMPORTE',
          field: 'importe',
          valueFormatter: function (param) {
            return formatearValorAMoneda(param.value);
          },
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'SALDO',
          field: 'saldo',
          valueFormatter: function (param) {
            if (param.node.rowPinned) {
              return undefined;
            }
            return formatearValorAMoneda(param.value);
          },
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'ESTADO',
          cellRenderer: function (param) {
            if (param.node.rowPinned) {
              return undefined;
            } else {
              const color = obtenerColorEstadoDetalleSolicitud(param.data.estado);

              return /*html */ `<span style="color: ${color};">${param.data.estado}</span>`;
            }
          },
          filter: false,
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'PROCESAR',
          filter: false,
          minWidth: 250,
          cellRenderer: function (param) {
            if (param.node.rowPinned) {
              return undefined;
            } else if (param.data.estado == ESTADOS_DETALLE_SOLICITUD.PENDIENTE) {
              return /*html */ `
              <button type="button" style="margin-bottom: 8px;" class="v-btn v-btn--outlined theme--light v-size--x-small success--text">
                  <span class="v-btn__content" data-action-type="${OPERACIONES_DETALLE_SOLICITUD.APROBAR}">
                      APROBAR
                      <i aria-hidden="true" class="v-icon notranslate mdi mdi-check"></i>
                  </span>
              </button>
              
              <button type="button" style="margin-bottom: 8px;" class="v-btn v-btn--outlined theme--light v-size--x-small error--text">
                  <span class="v-btn__content" data-action-type="${OPERACIONES_DETALLE_SOLICITUD.RECHAZAR}" >
                      RECHAZAR
                      <i aria-hidden="true" class="v-icon notranslate mdi mdi-close"></i>
                  </span>
              </button>`;
            } else {
              return undefined;
            }
          },
        },
      ],
    };
  },
  computed: {
    tituloModal() {
      if (!this.verificar) {
        return this.form.id
          ? 'EDITAR SOLICITUD DE TRANSFERENCIA DE RECURSOS'
          : 'REGISTRO DE SOLICITUD DE TRANSFERENCIA DE RECURSOS';
      }
      return `PROCESAR SOLICITUD DE TRANSFERENCIA DE RECURSOS`;
    },
    partidasItemsFiltradas() {
      return this.agregarDetalle.sede_destino.id == this.$store.state.CARGO.sede.id
        ? this.partidasItems
        : this.partidasItems.filter((partida) => partida.nombre.startsWith('9'));
    },
    peticionSedeId() {
      return this.$store.state.CARGO.sede.id;
    },
  },
  watch: {
    'agregarDetalle.clasificador': function (value) {
      if (!value) {
        this.agregarDetalle.saldo = 0;
      }
    },
  },
  methods: {
    getPartidasPresupuestos() {
      this.getPartidasPresupuestosMixin(this.$store.state.CARGO.sede.id);
    },
    async getCuentasOrigen() {
      this.getCuentasOrigenMixin(this.$store.state.CARGO.sede.id);
    },
    async abrirModal(accion, data = []) {
      this.resetearVariablesPrevisualizacion();

      switch (accion) {
        case 'registrar': {
          this.verificar = false;
          this.archivo = null;
          this.archivoBase64 = null;
          this.archivoExtension = null;
          this.archivoMimetype = null;
          this.form = {
            id: null,
            sede_origen_id: this.$store.state.CARGO.sede.id,
            sede_origen: this.$store.state.CARGO.sede.nombre,
            sede_id: null,
            sede: null,
            numero: '',
            tipo: TIPOS_SOLICITUD.RECURSOS,
            total: 0,
            user_id: this.$store.state.DATA_USER.id,
            user: `${this.$store.state.DATA_USER.nombres} ${this.$store.state.DATA_USER.pri_apellido} ${this.$store.state.DATA_USER.seg_apellido}`,
            detalle_solicitud: [],
          };
          break;
        }
        case 'actualizar': {
          this.verificar = false;
          this.archivo = null;
          this.archivoBase64 = null;
          this.archivoExtension = null;
          this.archivoMimetype = null;
          this.form = {
            id: data['id'],
            sede_origen_id: data['sede_origen_id'], // this.$store.state.CARGO.sede.id,
            sede_origen: data['sede_origen'], // this.$store.state.CARGO.sede.nombre,
            sede_id: data['sede_id'],
            sede: data['sede'],
            numero: data['numero'],
            tipo: TIPOS_SOLICITUD.RECURSOS,
            total: data['total'],
            user_id: data['user_id'], // this.$store.state.DATA_USER.id,
            user: data['user'], // `${this.$store.state.DATA_USER.nombres} ${this.$store.state.DATA_USER.pri_apellido} ${this.$store.state.DATA_USER.seg_apellido}`,
            detalle_solicitud: data['detalle_solicitud'].map((detalle) => ({
              id: detalle.id,
              sede_origen_id: detalle.sede_origen_id,
              sede_origen: detalle.sede_origen,
              sede_destino_id: detalle.sede_destino_id,
              sede_destino: detalle.sede_destino,
              cuenta_origen_id: detalle.cuenta_origen_id,
              cuenta_origen: detalle.cuenta_origen,
              banco_origen: detalle.banco_origen,
              cuenta_destino_id: detalle.cuenta_destino_id,
              cuenta_destino: detalle.cuenta_destino,
              banco_destino: detalle.banco_destino,
              detalle: detalle.detalle,
              saldo: detalle.saldo,
              importe: detalle.importe,
              clasificador: `${detalle.clasificador.codigo} ${detalle.clasificador.nombre}`,
              clasificador_id: detalle.clasificador.id,
              cuenta_contable: detalle.clasificador.cuenta_contable
                ? `${detalle.clasificador.cuenta_contable.codigo} ${detalle.clasificador.cuenta_contable.nombre}`
                : '-',
              estado: detalle.estado,
              archivo_id: detalle.archivo_id,
              archivo: detalle.archivo,
            })),
          };

          await Promise.all(
            data['detalle_solicitud'].map(async (detalle, i) => {
              await this.obtenerPartidaSaldo(detalle.sede_origen_id, detalle.clasificador_id, i);
            }),
          );

          this.gridApi?.refreshCells();
          break;
        }
        default: {
          window.console.log('No se reconoce la accion');
        }
      }

      this.agregarDetalle = {
        sede_destino: this.$store.state.CARGO.sede,
        cuenta_origen: null,
        cuenta_destino: null,
        detalle: null,
        saldo: 0,
        importe: '',
        clasificador: null,
        archivo: null,
        archivo_id: null,
      };

      this.getSedes();
      this.getCuentasOrigen();
      this.obtenerCuentasDestino();
      this.getPartidasPresupuestos();
      this.dialog = true;
    },
    agregar() {
      // if (parseFloat(this.agregarDetalle.importe) <= parseFloat(this.agregarDetalle.saldo)) {
      if (
        this.agregarDetalle.clasificador &&
        this.agregarDetalle.cuenta_origen &&
        this.agregarDetalle.cuenta_destino &&
        this.agregarDetalle.detalle &&
        this.agregarDetalle.importe > 0
      ) {
        /**
         * Quitado restriccion de que no se pueda agregar el mismo clasificador, cuenta origen y cuenta destino
         */
        // const clasificadorId = (detalle) => {
        //   return (
        //     detalle.clasificador_id === this.agregarDetalle.clasificador.id &&
        //     detalle.cuenta_origen_id === this.agregarDetalle.cuenta_origen.id &&
        //     detalle.cuenta_destino_id === this.agregarDetalle.cuenta_destino.id
        //   );
        // };

        // if (
        //   !this.form.detalle_solicitud.some(clasificadorId) ||
        //   this.agregarDetalle.clasificador.nombre.startsWith('9')
        // ) {
        this.form.detalle_solicitud.push({
          sede_origen_id: this.$store.state.CARGO.sede.id,
          sede_origen: this.$store.state.CARGO.sede.nombre,
          sede_destino_id: this.agregarDetalle.sede_destino.id,
          sede_destino: this.agregarDetalle.sede_destino.nombre,
          cuenta_origen_id: this.agregarDetalle.cuenta_origen.id,
          cuenta_origen: this.agregarDetalle.cuenta_origen.nro,
          banco_origen: this.agregarDetalle.cuenta_origen.nombre,
          cuenta_destino_id: this.agregarDetalle.cuenta_destino.id,
          cuenta_destino: this.agregarDetalle.cuenta_destino.nro,
          banco_destino: this.agregarDetalle.cuenta_destino.nombre,
          detalle: this.agregarDetalle.detalle,
          saldo: this.agregarDetalle.saldo,
          importe: this.agregarDetalle.importe,
          clasificador: this.agregarDetalle.clasificador.nombre,
          clasificador_id: this.agregarDetalle.clasificador.id,
          estado: ESTADOS_DETALLE_SOLICITUD.PENDIENTE,
          archivo: this.archivoBase64,
          extension: this.archivoExtension,
          mimetype: this.archivoMimetype,
        });
        this.agregarDetalle = {
          sede_destino: this.$store.state.CARGO.sede,
          cuenta_origen: null,
          cuenta_destino: null,
          detalle: null,
          saldo: 0,
          importe: '',
          clasificador: null,
          archivo: null,
          archivo_id: null,
        };
        this.archivo = null;
        this.archivoBase64 = null;
        this.archivoExtension = null;
        this.archivoMimetype = null;
        this.gridApi?.refreshCells();
        // } else {
        // this.$notify({
        //   group: 'notifications',
        //   title: 'Error',
        //   text: 'La cuenta, la cuenta origen y la cuenta destino ya se agregaron',
        //   type: 'error',
        // });
        // }
      } else {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Se debe llenar todos los campos para agregar un detalle',
          type: 'error',
        });
      }
      // } else {
      //   this.$notify({
      //     group: 'notifications',
      //     title: 'SALDO INSUFICIENTE',
      //     text: 'Error',
      //     type: 'error',
      //   });
      // }
    },
    obtenerSede() {
      this.form.sede = this.form.sede_id ? this.sedeItems.find((p) => p.id === this.form.sede_id).nombre : '';
    },
  },
};

function numberParser(params) {
  if (!isNaN(params.newValue) && params.newValue >= 0) {
    return Number(params.newValue).toFixed(2);
  } else {
    return 0;
  }
}
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';
.v-dialog {
  align-items: flex-start;
}

.ag-grid-table-presupuesto-modal-solicitud {
  height: calc(var(--vh, 1vh) * 100 - 24rem);
}

@media (min-height: 768px) {
  .ag-grid-table-presupuesto-modal-solicitud {
    height: calc(var(--vh, 1vh) * 100 - 28rem);
  }
}

.ag-theme-balham .nuevo-registro {
  color: #309c51 !important;
}
</style>

<style scoped>
::v-deep .col,
.col-1,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-10,
.col-11,
.col-12,
.col-auto,
.col-lg,
.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-auto,
.col-md,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-auto,
.col-sm,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-auto,
.col-xl,
.col-xl-1,
.col-xl-2,
.col-xl-3,
.col-xl-4,
.col-xl-5,
.col-xl-6,
.col-xl-7,
.col-xl-8,
.col-xl-9,
.col-xl-10,
.col-xl-11,
.col-xl-12,
.col-xl-auto {
  width: 100%;
  padding: 8px;
}
hr {
  margin-top: 8px;
  margin-bottom: 10px;
  border: 0;
  border-top: 1px solid #eee;
}
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}
::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}
::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}
::v-deep .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer {
  margin-top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}

::v-deep .container,
.container-fluid {
  padding-right: 0px;
  padding-left: 0px;
}

::v-deep .container {
  width: 100%;
  padding: 0px;
  margin-right: auto;
  margin-left: auto;
}

::v-deep .file-input .v-text-field__slot {
  min-height: 32px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

::v-deep .file-input .v-input__prepend-inner {
  margin-top: 4px !important;
}
</style>
  <style>
.mood {
  border-radius: 15px;
  border: 1px solid grey;
  background: #e6e6e6;
  padding: 15px;
  text-align: center;
  display: inline-block;
  outline: none;
}

.default {
  border: 1px solid transparent !important;
  padding: 4px;
}

.selected {
  border: 1px solid lightgreen !important;
  padding: 4px;
}

.simple-input-editor {
  width: 100%;
  height: 100%;
}
</style>
  